import { render, staticRenderFns } from "./fundStatistics.vue?vue&type=template&id=3a0b5474&scoped=true&"
import script from "./fundStatistics.vue?vue&type=script&lang=js&"
export * from "./fundStatistics.vue?vue&type=script&lang=js&"
import style0 from "./fundStatistics.vue?vue&type=style&index=0&id=3a0b5474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b5474",
  null
  
)

export default component.exports